<div class="coaching-card">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._9916_MY_COACHING | translate"
        [isLoading]="state.pending.reload"
        [hasExpandAction]="state.pending.hasData"
        [isExpanded]="_isExpanded"
        [refreshButtonTooltip]="_i18n._11174_RESET_CARD | translate"
        [expandButtonTooltip]="
            _isExpanded === false
                ? (_i18n._11176_EXPAND_CARD | translate)
                : (_i18n._11175_COLLAPSE_CARD | translate)
        "
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        (expandAction)="_toggleExpand()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-coaching-card--no-data">
            <h2 class="my-coaching-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>
    <ng-container *ngIf="state?.cardItems">
        <ng-container *ngIf="_isExpanded === false">
            <ng-container
                *ngFor="let item of state.cardItems; let rowIndex = index"
            >
                <cmps-card-header-row-component
                    *ngIf="_isExpanded == false && state.pending.hasData"
                    [cardHeaderLabel]="item.headerData?.titleLabel | translate"
                    [timePeriod]="item.headerData?.periodDate"
                    [isShowingIcon]="false"
                ></cmps-card-header-row-component>

                <div class="data-rows-container">
                    <ng-template
                        ngFor
                        let-i
                        [ngForOf]="item.cardRowsData"
                    >
                        <cmps-metric-performance
                            *ngIf="i.metricPerformanceData"
                            [metricData]="i.metricPerformanceData"
                            [cmps-metric-performance]="i.metricPerformanceData"
                            showTrend="true"
                            (clickAction)="_toggleExpand(item?.type)"
                            (trendAction)="_trendView(item?.type)"
                        ></cmps-metric-performance>
                    </ng-template>
                </div> </ng-container
        ></ng-container>
        <ng-container *ngIf="_isExpanded === true">
            <div cmpsWidgetCoachingInsightNext></div>
        </ng-container>
    </ng-container>
</ng-template>
